import React, {PureComponent} from "react"

import braze from "@irati/braze/services/braze"
import UserMenuContext from "./UserMenu"
import SecondaryNavContext from "../../shared/SecondaryNavContext"
import {NOTIFICATION_CENTER_CONTEXT, SECONDARY_NAV_CONTEXT, USER_MENU_CONTEXT, WALLET_MENU_CONTEXT} from "../const"
import MobileWalletDropdown from "../MobileWalletDropdown"
import ContentCardsContainer from "../../shared/Notifications/ContentCardsContainer"

interface Props {
  currentContext: string
}

class MenuContexts extends PureComponent<Props> {
  render() {
    const {currentContext} = this.props
    switch (currentContext) {
      case USER_MENU_CONTEXT:
        return <UserMenuContext />
      case SECONDARY_NAV_CONTEXT:
        return <SecondaryNavContext />
      case WALLET_MENU_CONTEXT:
        return <MobileWalletDropdown />
      case NOTIFICATION_CENTER_CONTEXT:
        return <ContentCardsContainer cards={braze.getContentCards()} />
      default:
        return null
    }
  }
}

export default MenuContexts
